import React, { useState, useEffect } from 'react';
import './BlogFilters.scss';
import { useBlogCategoriesQuery } from '../../../../hooks/useBlogQuery';
import SvgIcons from '../../../../services/SvgIcons';

const BlogFilters = ({ 
    searchTerm, 
    sortOrder, 
    selectedCategory,
    onSearchChange, 
    onSortChange,
    onCategoryChange,
    resultsCount 
}) => {
    const { data: categories = [], isLoading: categoriesLoading } = useBlogCategoriesQuery();
    
    // État local pour la valeur de l'input de recherche
    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);

    // État pour gérer l'ouverture/fermeture du select
    const [isSelectOpen, setIsSelectOpen] = useState(false);

    // Protection supplémentaire pour s'assurer que categories est un tableau
    const categoriesList = Array.isArray(categories) ? categories : [];

    // Synchroniser la valeur locale avec la prop quand elle change de l'extérieur
    useEffect(() => {
        setLocalSearchTerm(searchTerm);
    }, [searchTerm]);

    // Debouncing: déclencher la recherche après 500ms sans saisie
    useEffect(() => {
        const timer = setTimeout(() => {
            if (localSearchTerm !== searchTerm) {
                onSearchChange(localSearchTerm);
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [localSearchTerm, searchTerm, onSearchChange]);

    const handleSearchInputChange = (e) => {
        setLocalSearchTerm(e.target.value);
    };

    const handleSortChange = (e) => {
        onSortChange(e.target.value);
    };

    const handleCategoryClick = (category) => {
        onCategoryChange(category);
    };

    // Gestionnaires pour l'état du select
    const handleSelectBlur = () => {
        setIsSelectOpen(false);
    };

    const handleSelectClick = () => {
        setIsSelectOpen(!isSelectOpen);
    };

    return (
        <div className="blog-filters">
            <div className="blog-filters__container">
                {/* Barre de recherche et tri */}
                <div className="blog-filters__controls">
                    {/* Recherche */}
                    <div className="blog-filters__search">
                        <input
                            type="text"
                            placeholder="Rechercher..."
                            value={localSearchTerm}
                            onChange={handleSearchInputChange}
                            className="blog-filters__search-input"
                        />
                    </div>

                    {/* Tri */}
                    <div className="blog-filters__sort">
                        <select 
                            value={sortOrder} 
                            onChange={handleSortChange}
                            onBlur={handleSelectBlur}
                            onClick={handleSelectClick}
                            className="blog-filters__sort-select"
                        >
                            <option value="DateEnvoi:desc">Plus récentes</option>
                            <option value="DateEnvoi:asc">Plus anciennes</option>
                            <option value="Sujet:asc">A-Z</option>
                            <option value="Sujet:desc">Z-A</option>
                        </select>

                        {/* Chevron */}
                        <div className="blog-filters__sort-chevron"
                            style={{ transform: isSelectOpen ? 'translateY(-50%) rotate(90deg)' : 'translateY(-50%) rotate(-90deg)' }}>
                            <SvgIcons
                                name="chevron_back"
                                width={20}
                                height={20}
                                color="#6B7280"                                
                            />
                        </div>
                    </div>
                </div>

                {/* Catégories */}
                <div className="blog-filters__categories">
                    <div className="blog-filters__categories-list">
                        {/* Bouton "Tous" */}
                        <button
                            className={`blog-filters__category-btn ${
                                selectedCategory === 'tous' ? 'blog-filters__category-btn--active' : ''
                            }`}
                            onClick={() => handleCategoryClick('tous')}
                        >
                            Tous
                            {selectedCategory === 'tous' && (
                                <span className="blog-filters__category-count">({resultsCount})</span>
                            )}
                        </button>

                        {/* Boutons des catégories */}
                        {categoriesLoading ? (
                            <div className="blog-filters__categories-loading">
                                Chargement des catégories...
                            </div>
                        ) : (
                            categoriesList.map((category) => (
                                <button
                                    key={category.id}
                                    className={`blog-filters__category-btn ${
                                        selectedCategory === category.Nom ? 'blog-filters__category-btn--active' : ''
                                    }`}
                                    onClick={() => handleCategoryClick(category.Nom)}
                                >
                                    {category.Nom}
                                    {selectedCategory === category.Nom && (
                                        <span className="blog-filters__category-count">({resultsCount})</span>
                                    )}
                                </button>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogFilters;